/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { Check } from "../../icons/Check";
import "./style.css";

export const CmpWorkoutcard = ({ state, text = "Week 2 • Day 3" }) => {
  return (
    <div className="cmp-workoutcard">
      <p className="week-day">{text}</p>

      <div className="text-wrapper-4">Long walk</div>

      <div className="badge-wrapper">
        <div className="badge">
          <Check className="check-instance" />
        </div>
      </div>
    </div>
  );
};

CmpWorkoutcard.propTypes = {
  state: PropTypes.oneOf(["done"]),
  text: PropTypes.string,
};
